import React from 'react'

export default function Loader() {
  return (
    <div className='loader-fullscreen'>
        <span className="loader"></span>

    </div>
  )
}
